
import { ReviewItem, ReviewItemProps } from "./ReviewItem";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface ReviewListProps {
  reviews: ReviewItemProps[];
  title?: string;
  isLoading?: boolean;
}

export const ReviewList = ({ reviews, title = "리뷰", isLoading = false }: ReviewListProps) => {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {[1, 2, 3].map((index) => (
              <div key={index} className="flex items-start gap-3">
                <Skeleton className="h-10 w-10 rounded-full" />
                <div className="space-y-2 flex-1">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-20 w-full" />
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (reviews.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-center py-4">아직 리뷰가 없습니다.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title} ({reviews.length})</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {reviews.map((review, index) => (
            <ReviewItem key={index} {...review} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
